<template>
  <div>
    <div class="calculator-input-values">
      <h5>Данные для расчета</h5>
      <p class="calculator-comment">Укажите расходы используемых материалов</p>
      <table>
        <tbody>
          <tr>
            <td>Формат плитки, см</td>
            <td>
              <select class="calc-tiling-tile-format" v-model="tileFormat">
                <option :value="1">Мозаика</option>
                <option :value="2">до 10 x 10</option>
                <option :value="3">до 15 x 15</option>
                <option :value="4">до 30 x 30</option>
                <option v-if="tile40" :value="5">до 40 x 40</option>
                <option v-if="tile60" :value="6">60 x 60 и более</option>
              </select>
            </td>
          </tr>

          <tr>
            <td>Площадь, кв.м</td>
            <td>
              <input
                v-model="area"
                id="calc-tiling-square"
                type="number"
                placeholder="0"
                :min="1"
                :max="1500"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="calculator-output-values">
      <h5>Результаты расчета</h5>
      <table>
        <thead>
          <tr>
            <th colspan="2">Результаты расчета</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>Высота зуба шпателя (мм):</td>
            <td
              class="calc-result-value-container"
              id="calc-tiling-tooth-depth"
            >
              {{ toothHeight }}
            </td>
          </tr>
          <tr>
            <td>Расход клея (л/м<sup>2</sup>):</td>
            <td
              class="calc-result-value-container"
              id="calc-tiling-expense"
              width="100"
            >
              {{ expense }}
            </td>
          </tr>
          <tr>
            <td>Потребуется сухой смеси (кг):</td>
            <td
              class="calc-result-value-container"
              id="calc-tiling-need-dry-mix"
            >
              {{ dryWeight }}
            </td>
          </tr>
          <tr>
            <td>Потребуется мешков сухой смеси (шт):</td>
            <td
              class="calc-result-value-container"
              id="calc-tiling-need-25-packs"
            >
              {{ pack25Count }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    this.thickness = this.minThickness;
  },
  data() {
    return {
      tileFormat: 1,
      area: 1,
    };
  },
  props: {
    tile40: Boolean,
    tile60: Boolean,
  },
  computed: {
    toothHeight() {
      if (this.tileFormat === 1) {
        return 3;
      } else if (this.tileFormat === 2) {
        return 4;
      } else if (this.tileFormat === 3) {
        return 6;
      } else if (this.tileFormat === 4) {
        return 8;
      } else if (this.tileFormat === 5) {
        return 10;
      } else {
        return 12;
      }
    },
    expense() {
      if (this.tileFormat === 1) {
        return 1.36;
      } else if (this.tileFormat === 2) {
        return 1.81;
      } else if (this.tileFormat === 3) {
        return 2.72;
      } else if (this.tileFormat === 4) {
        return 3.63;
      } else if (this.tileFormat === 5) {
        return 4.53;
      } else {
        return 5.44;
      }
    },
    dryWeight() {
      return (this.area * this.expense).toFixed(2);
    },
    pack25Count() {
      return Math.ceil(this.dryWeight / 25);
    },
  },
};
</script>

<style lang="scss" scoped>
.calc-tiling-tile-format {
  appearance: menulist;
  min-width: 168px;
}
</style>
